import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function TwitterIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M21.543 7.10378C21.5576 7.31547 21.5576 7.52697 21.5576 7.74053C21.5576 14.2468 16.6044 21.7505 7.54763 21.7505V21.7468C4.87202 21.7505 2.25186 20.9842 0 19.5392C0.389063 19.586 0.78 19.6095 1.17188 19.6104C3.38946 19.6122 5.54326 18.8684 7.28719 17.4986C6.25968 17.4792 5.26392 17.1392 4.43914 16.5261C3.61436 15.913 3.00178 15.0575 2.68706 14.0792C3.42525 14.2217 4.18575 14.1922 4.91025 13.9942C2.613 13.5302 0.960375 11.5119 0.960375 9.16797V9.10553C1.64518 9.48704 2.41163 9.69841 3.19519 9.72185C1.03125 8.27585 0.364688 5.39753 1.67119 3.14735C2.90736 4.66847 4.44967 5.91255 6.19797 6.79877C7.94626 7.685 9.86142 8.19356 11.8191 8.29141C11.6239 7.45118 11.6528 6.57444 11.9028 5.74887C12.1528 4.92331 12.6152 4.17784 13.2437 3.58703C15.2269 1.72272 18.3459 1.81835 20.2101 3.80059C21.3128 3.58286 22.3703 3.17856 23.337 2.6051C22.9694 3.74523 22.2002 4.71304 21.1725 5.32853C22.1486 5.21345 23.1017 4.95208 24 4.55322C23.3392 5.54277 22.5072 6.40649 21.543 7.10378Z"
        fill="#1D9BF0"
      />
    </svg>
  );
};
